import React from 'react';
import { useSelector } from 'react-redux';
import './customStyles.css';
import { useActiveTab } from './hooks/useActiveTab';
import { useWhatsAppMode } from './hooks/useWhatsAppMode';
import ProdytAuthContainer from './components/auth/prodyt/ProdytAuthContainer';
import WhatsAppAuthContainer from './components/auth/whatsapp/WhatsAppAuthContainer';

export default function withCustomAuthenticator(WrappedComponent) {
  return function AuthenticatedApp() {
    const [activeTab] = useActiveTab();
    const [mode] = useWhatsAppMode();
    const isUserAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const isAuthLoading = useSelector((state) => state.auth.isAuthLoading);

    React.useEffect(() => {
      const authContainer = document.querySelector('[data-amplify-authenticator]');
      if (authContainer) {
        if (activeTab === 'whatsapp' && mode === 'signUp') {
          authContainer.setAttribute('data-whatsapp-signup', 'true');
        } else {
          authContainer.setAttribute('data-whatsapp-signup', 'false');
        }
      }
    }, [activeTab, mode]);

    if (isAuthLoading) {
      return <WrappedComponent />;
    }

    if (isUserAuthenticated) {
      return <WrappedComponent />;
    }

    if (activeTab === 'prodyt') {
      return (
        <div style={{ display: 'flex', minHeight: '100vh' }}>
          <ProdytAuthContainer />
          <div style={{ display: 'none' }}>
            <WrappedComponent />
          </div>
        </div>
      );
    }

    return (
      <div style={{ display: 'flex', minHeight: '100vh' }}>
        <WhatsAppAuthContainer />
        <div style={{ display: 'none' }}>
          <WrappedComponent />
        </div>
      </div>
    );
  };
}